import request from '@/utils/request'

export function updateOrder(data) {
    return request({
        url: '/acode/api/admin/order/update',
        method: 'post',
        data
    })
}

export function getOrderList(data) {
    return request({
        url: '/acode/api/admin/order/list',
        method: 'post',
        data
    })
}


